<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <!-- <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button> -->
    </template>
    <template slot="body">
      <form-preview v-if="show == true" :id="form_body_id" :form_id="form_id" :form_revision_id="form_revision_id" :taskId="task_id"></form-preview>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";
import { axiosGet} from "../../../../../../Helpers/AxiosHelper";
import {
  JOB_REVIEW_FORM_SHOW,
} from "../../../../../../Config/ApiUrl";

export default {
  name: "FormBuilderModal",
  mixins: [ModalMixin],
  props: {
    id: Number,
  },
  data() {
    return {
      show: false,
      task_id: 0,
      form_revision_id: 0,
      form_id: 0,
      form_body_id: 0,
      modalId: "form-view-Modal",
      modalTitle: this.$t("Review & Feedback"),
    };
  },
   methods: {
    getData() {

      axiosGet(`${JOB_REVIEW_FORM_SHOW}/${this.id}`)
        .then((res) => {
          this.task_id = this.id;
          this.form_id = res.data.form_id;
          this.form_body_id = res.data.form_body_id;
          this.form_revision_id = res.data.id;
          this.show = true;
        })
        .catch((res) => {
          console.error(res);
        });
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  },
};
</script>
